<div class="togo-page">
  @if (displayLoading) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-loading-container"
    >
      <div class="w-25 text-center">
        <img class="common-loading" src="assets/menu_loading.gif" alt="common loading" />
        <p class="common-loading-text">Loading ToGo, please wait...</p>
      </div>
    </div>
  } @else {
    <div class="togo-card">
      <div class="card-heading">
        <span class="card-title">To Go &amp; Dining Settings</span>
        <span class="card-subtitle">
          Configure your pickup options, table dining availability, and generate your store QR
          ordering codes.
        </span>
      </div>

      @if (isPosNotSelected) {
        <div class="section">
          <span class="section-label">To Go Settings</span>
          <div class="setting-row">
            <span class="setting-icon"><i class="bx bx-qr"></i></span>
            <div class="setting-text">
              <span class="setting-title">Enable Fork &amp; Find to get your ordering QR</span>
              <span class="setting-desc">
                Your restaurant isn't taking orders yet. Enable Fork &amp; Find to switch on To Go
                ordering and generate your store QR code.
              </span>
            </div>
            <button
              type="button"
              class="download-btn"
              [disabled]="enablingFnf"
              (click)="enableFnf()"
            >
              {{ enablingFnf ? 'Enabling...' : 'Enable Fork & Find' }}
            </button>
          </div>
        </div>
      } @else {
        <div class="section">
          <span class="section-label">To Go Settings</span>

          @if (togos.length > 0) {
            <div class="setting-row">
              <span class="setting-icon"><i class="bx bx-shopping-bag"></i></span>
              <div class="setting-text">
                <span class="setting-title">Enable To Go Feature</span>
                <span class="setting-desc"
                  >This will allow customers to place orders for pickup.</span
                >
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  role="switch"
                  [checked]="isCheckedTogoFeature"
                  (change)="toggleTogoFeature($event)"
                  [disabled]="saving['togo']"
                  aria-label="Enable To Go Feature"
                />
                <span class="slider"></span>
              </label>
            </div>

            <div class="setting-row">
              <span class="setting-icon"><i class="bx bx-group"></i></span>
              <div class="setting-text">
                <span class="setting-title">Enable To Go Dining Feature</span>
                <span class="setting-desc">
                  This will allow the customers to dine in the restaurant.
                </span>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  role="switch"
                  [checked]="isCheckedTogoDiningFeature"
                  (change)="toggleTogoDiningFeature($event)"
                  [disabled]="saving['togo_dine_in']"
                  aria-label="Enable To Go Dining Feature"
                />
                <span class="slider"></span>
              </label>
            </div>

            @if (isCheckedTogoDiningFeature) {
              <div
                class="sub-setting"
                @dropFromDining
                [@.disabled]="!subSettingAnimates || prefersReducedMotion"
              >
                <div class="setting-row setting-row-sub">
                  <span class="setting-icon"><i class="bx bx-table"></i></span>
                  <div class="setting-text">
                    <span class="setting-title">Require Table Number</span>
                    <span class="setting-desc">
                      Customers dining in must enter their table number. When off, the table number
                      is not asked.
                    </span>
                  </div>
                  <label class="switch">
                    <input
                      type="checkbox"
                      role="switch"
                      [checked]="isTableNumberRequired"
                      (change)="toggleTableNumberRequired($event)"
                      [disabled]="saving['table_number_required']"
                      aria-label="Require Table Number"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
            }
          } @else {
            <div class="setting-row">
              <span class="setting-icon"><i class="bx bx-qr"></i></span>
              <div class="setting-text">
                <span class="setting-title">Generate To Go Feature</span>
                <span class="setting-desc">This will generate a QR code for the togo feature.</span>
              </div>
              <label class="switch">
                <input
                  type="checkbox"
                  role="switch"
                  [checked]="false"
                  (change)="generateTogoFeature($event)"
                  aria-label="Generate To Go Feature"
                />
                <span class="slider"></span>
              </label>
            </div>
          }
        </div>
      }

      @if (!isPosNotSelected && togos.length > 0 && isCheckedTogoFeature) {
        <div class="section">
          <span class="section-label">QR Code</span>

          <div class="qr-block">
            <div class="qr-frame">
              <img #qrCodeImage [src]="displayQrCodePath" alt="QR Code" class="qrCodeLarge" />
            </div>
            <span class="qr-caption">Scan to place your order</span>

            <div class="qr-actions">
              <button type="button" class="download-btn" (click)="downloadQR(togos[0])">
                <i class="bx bx-download"></i>
                Download QR Code
              </button>
              <div class="btn-group custom-dropdown1">
                <button
                  type="button"
                  class="more-actions-btn dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  More Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-lg-end">
                  <li>
                    <a class="dropdown-item type-option" (click)="downloadAsPNG(togos[0])">
                      <i class="bx bx-image"></i>
                      Download as PNG
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item type-option" (click)="printQR(togos[0])">
                      <i class="bx bx-printer"></i>
                      Print QR
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
